import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/styles';
import { useStyles } from './styles';

const Props = {
  element: PropTypes.func.isRequired,
  error: PropTypes.bool.isRequired,
  options: PropTypes.object,
  onChange: PropTypes.func.isRequired,
};

const DefaultProps = {
  options: {},
};

export default function StripeElement({ element: Element, error, options, onChange }) {
  const theme = useTheme();
  const classes = useStyles();
  const [styleOptions, setStyleOptions] = useState({});

  function getStyleOptions() {
    const baseStyleOptions = {
      classes: { base: `${classes.base}` },
      style: {
        base: {
          fontSize: `${theme.typography.htmlFontSize}px`,
          color: theme.palette.text.primary,
        },
        invalid: { color: theme.palette.text.primary },
      },
    };

    if (error) {
      return {
        ...baseStyleOptions,
        classes: { base: `${classes.base} ${classes.error}` },
      };
    }

    return baseStyleOptions;
  }

  function handleFocus() {
    setStyleOptions({
      ...styleOptions,
      classes: { base: `${classes.base} ${classes.focus}` },
    });
  }

  function handleBlur() {
    setStyleOptions({
      ...styleOptions,
      classes: { base: classes.base },
    });
  }

  useEffect(() => {
    const newStyleOptions = getStyleOptions();
    setStyleOptions(newStyleOptions);
  }, [classes, error]);

  return (
    <Element
      options={{ ...styleOptions, ...options }}
      onFocus={handleFocus}
      onBlur={handleBlur}
      onChange={onChange}
    />
  );
}

StripeElement.propTypes = Props;
StripeElement.defaultProps = DefaultProps;
